import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { IrFieldsService } from '../../shared/services/ir-fields.service';
import { CompanySetupService } from '../../shared/services/company-setup.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';

@Component({
  selector: 'app-generic-afterdiv-list', templateUrl: './generic-afterdiv-list.component.html', styleUrls: ['./generic-afterdiv-list.component.scss'],
  providers:[CompanySetupService,WebServiceService]

})
export class GenericAfterdivListComponent implements OnInit {
  @Input() divDetails: any;
  @Input() options:any;
  @Output()
  sendAction = new EventEmitter()
  commonVariableList: any = { "divList": [], };
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  page_url:any=window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  constructor(private toasterService: ToasterService, private webservice: WebServiceService, public irFields: IrFieldsService,public comanySetup:CompanySetupService,public _localStorageService: LocalStorageService) { }
  company_setup: any = {};
  setup:any={}

  quotation_Attachments:any=[];
  quotation_obtained:any=''
  no_of_quotation:any=''

  getRemarksLabel(): string {
    if (this.divDetails && this.divDetails.id === 'prreport') {
      return (this.company_setup && this.company_setup.custome_name_for_remarks_in_pr) ? this.company_setup.custome_name_for_remarks_in_pr : 'Remarks';
    }
    return 'Remarks';
  }
  ngOnInit() {
    //console.log(this.options);
    this.options=this.options?this.options:{};
    this.options.apply_option=this.options.apply_option?this.options.apply_option:'0';
    if(this.options.apply_option=='1')
    {
    this.options.all_div_visible=this.options.all_div_visible;
    this.options.is_hold_info_visible=this.options.is_hold_info_visible;
    }
    else
    {
      this.options.all_div_visible=this.options.all_div_visible?this.options.all_div_visible:true
      this.options.is_hold_info_visible=this.options.is_hold_info_visible?this.options.is_hold_info_visible:true
    }
    this.setup=this.divDetails.setup?this.divDetails.setup:{}
    this.setup.is_setup=this.divDetails.is_setup?this.divDetails.is_setup:false;
    if(this.setup.is_setup)
    {
      this.setSetupData(this.setup);
    }
    else
    {
    this.GetCompanySetUpData();
    }
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
   this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
  }

  po_type_list : any = [];
  GetCompanySetUpData() {
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '')
{
  return false;
}
    let req:any={}
    this.company_setup={}
    this.company_setup.invoice_extra_columns =  [];
    this.webservice.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status)
        {
          this.setSetupData(data.response);
        }

      }, error => {

      }
    )
  }
  setSetupData(data)
  {
    this.company_setup={}
    this.company_setup.invoice_extra_columns =  [];
    this.company_setup=data ? data : {}
    this.company_setup.generice_ui_paragraph_color_code= this.company_setup.generice_ui_paragraph_color_code? this.company_setup.generice_ui_paragraph_color_code:'#53a75c';
    this.company_setup.generice_ui_heading_color_code= this.company_setup.generice_ui_heading_color_code? this.company_setup.generice_ui_heading_color_code:'#333';
    this.company_setup.is_quotation_table_visible_or_not_in_po=this.company_setup.is_quotation_table_visible_or_not_in_po?this.company_setup.is_quotation_table_visible_or_not_in_po:'0',
    this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "dd-mm-yyyy";

    this.company_setup.invoice_extra_columns =this.company_setup.invoice_extra_columns?this.company_setup.invoice_extra_columns: [];
    let temp: any = [];
    temp = this.company_setup.invoice_extra_columns.filter((v) => { return v.id == 'grn_invoice' });
    if (temp.length != undefined && temp.length>0) {
      this.company_setup.invoice_extra_columns = [];
      this.company_setup.invoice_extra_columns = temp[0].columns ? temp[0].columns : [];
    }
    this.company_setup.proposed_pod_deduction_amount_visible=this.webservice.is_column_visible(this.company_setup.invoice_extra_columns,'proposed_pod_deduction_amount',false);
      this.company_setup.proposed_cod_deduction_amount_visible=this.webservice.is_column_visible(this.company_setup.invoice_extra_columns,'proposed_cod_deduction_amount',false);

      this.company_setup.approved_pod_deduction_amount_visible=this.webservice.is_column_visible(this.company_setup.invoice_extra_columns,'approved_pod_deduction_amount',false);
      this.company_setup.approved_cod_deduction_amount_visible=this.webservice.is_column_visible(this.company_setup.invoice_extra_columns,'approved_cod_deduction_amount',false);

      this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '';
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
      this.company_setup.product_catalog_id = '1'
    }
    // this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';

    this.company_setup.is_remarks_require_in_invoice = this.company_setup.is_remarks_require_in_invoice ? this.company_setup.is_remarks_require_in_invoice : '0';
    this.company_setup.mode_of_payment_po_visible = this.company_setup.mode_of_payment_po_visible ? this.company_setup.mode_of_payment_po_visible : '0';
    this.company_setup.is_advance_amt_visible_in_add_direct_po = this.company_setup.is_advance_amt_visible_in_add_direct_po ? this.company_setup.is_advance_amt_visible_in_add_direct_po : '0';
    this.company_setup.is_payment_terms_visible_in_add_direct_po = this.company_setup.is_payment_terms_visible_in_add_direct_po ? this.company_setup.is_payment_terms_visible_in_add_direct_po : '';
    this.company_setup.is_advance_amt_percentage_visible_in_add_direct_po = this.company_setup.is_advance_amt_percentage_visible_in_add_direct_po ? this.company_setup.is_advance_amt_percentage_visible_in_add_direct_po:'';
    this.company_setup.is_so_ref_no_visible_in_add_direct_po = this.company_setup.is_so_ref_no_visible_in_add_direct_po ? this.company_setup.is_so_ref_no_visible_in_add_direct_po : '0';
    this.company_setup.custom_name_for_terms_and_conditions_in_direct_po=this.company_setup.custom_name_for_terms_and_conditions_in_direct_po?this.company_setup.custom_name_for_terms_and_conditions_in_direct_po:'Terms & conditions';
    this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "dd-mm-yyyy";
    this.company_setup.comma_separate_currency_code = this.company_setup.comma_separate_currency_code ? this.company_setup.comma_separate_currency_code : 'IND';
    this.company_setup.is_enable_comma_separate_price = this.company_setup.is_enable_comma_separate_price ? this.company_setup.is_enable_comma_separate_price : '0';
    this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : '2';
    this.company_setup.enable_po_type_order_in_po = this.company_setup.enable_po_type_order_in_po ? this.company_setup.enable_po_type_order_in_po : '0';
    this.company_setup.po_type_order_dropdown_list = this.company_setup.po_type_order_dropdown_list ? this.company_setup.po_type_order_dropdown_list : [];
    this.po_type_list =  this.company_setup.po_type_order_dropdown_list.filter(item => item.is_visible);

    if (this.divDetails.data) { this.apiCall(); }
  }
   apiCall() {
    this.commonVariableList.divList = [];
    switch (this.divDetails.id) {
      case 'invoice_android_report': this.showAndroidInvoice(this.divDetails.data); break;
      case 'recurring_invoicereport': this.showRecurringInvoice(this.divDetails.data); break;

      case 'invoicereport': this.showInvoice(this.divDetails.data); break;
      case 'dcnotereport': this.showDCNote(this.divDetails.data); break;

      case 'grnreport': this.showGrn(this.divDetails.data); break;
      case 'irnreport': this.showIrn(this.divDetails.data); break;
      case 'poreport': this.showPo(this.divDetails.data); break;
      case 'mpreport': this.showMp(this.divDetails.data); break;
      case 'logisticsreport': this.showLogistics(this.divDetails.data); break;

      case 'sireport': this.showSi(this.divDetails.data); break;
      case 'prreport': this.showPr(this.divDetails.data); break;
      case 'irreport': this.showIr(this.divDetails.data); break;
      case 'ir_history_report': this.showIRHistory(this.divDetails.data); break;

      case 'mprreport': this.showMpr(this.divDetails.data); break;

      case 'stnreport': this.showStn(this.divDetails.data); break;
      case 'proformainvoicereport': this.showProformaInvoice(this.divDetails.data); break;
      case 'salesinvoicereport': this.showSalesInvoice(this.divDetails.data); break;
      case 'invoicepaymentreport': this.showInvoicePayment(this.divDetails.data); break;
      case 'adhocpaymentreport': this.showAdhocPayment(this.divDetails.data); break;

      case 'invoicepartpaymentreport': this.showInvoicePartPayment(this.divDetails.data); break;
      case 'invoiceretentionpaymentreport': this.showInvoiceRetentionPayment(this.divDetails.data); break;
      case 'popaymentreport': this.showPoPayment(this.divDetails.data); break;
      case 'salesOrderData': this.showSalesData(this.divDetails.data); break;
      case 'my_advance_report': this.showMyAdvanceData(this.divDetails.data); break;
      case 'employee_advance_payment_report': this.showEmployeeAdvancePaymentData(this.divDetails.data); break;


      default:
      // this.toasterService.pop('error', "Error", "Wrong Data For After Div");
    }
  }

  showPoPayment(response) {
    this.commonVariableList.divList.push(
      {
        "display": 'Payment Reference Number', "value": response.payment_reference_no, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      });
  }


  showInvoicePayment(response) {
    response.info_history = response.info_history ? response.info_history : [];
    if(response.info_history)
    {
      for(let i of response.info_history)
      {
        i.add_approval_info_remarks=i.add_approval_info_remarks?i.add_approval_info_remarks:'';
        i.requested_by_remarks=i.requested_by_remarks?i.requested_by_remarks:''
        i.attachments=i.attachments?i.attachments:[]
        i.attachment=[];
        i.attachment=this.webservice.makeAttachment(i.attachments);
      }
    }
    //console.log(response.info_history);
    response.is_history_only = response.is_need_info ? response.is_need_info : false;
    response.is_need_info = response.info_history.length > 0 ? true : false;

    response.add_approval_info_remarks = response.add_approval_info_remarks ? response.add_approval_info_remarks : ''
    response.add_requested_by = response.add_requested_by ? response.add_requested_by : ''
    response.payment_mode=response.payment_mode?response.payment_mode:''
      this.commonVariableList.divList.push(
        {
          "display": 'Payment Reference Number', "value": response.payment_reference_no, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.payment_reference_no!=''&&response.payment_reference_no!=undefined)?true:false, "input_type": 'text'
        },
        {
          "display": 'Required Additional Info', "value": response.add_approval_info_remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.add_approval_info_remarks!='' && response.add_approval_info_remarks!=undefined) ? true : false, "input_type": 'text'
        },
        {
          "display": 'Additional Info Requested By', "value": response.add_requested_by, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.add_requested_by!=''&&response.add_requested_by!=undefined) ? true : false, "input_type": 'text'
        },
        {
          "display": 'Additional Info History', "value": (response.info_history?response.info_history:[]), "div_size": 'col-sm-12', "is_history": true, "is_array": true, "is_attachment": true, "is_disabled": true, "is_view": (response.is_need_info && this.isCorrectData(response.info_history)) ? true : false, "input_type": 'text'
        },
        {
          "display": 'Payment Mode', "value": response.payment_mode, "div_size": 'col-sm-12', "is_history": true, "is_array": true, "is_attachment": true, "is_disabled": true, "is_view": (response.payment_mode!=''&&response.payment_mode!=null&&response.payment_mode!=undefined)?true : false, "input_type": 'text'
        }
      );
      this.commonVariableList.divList= this.commonVariableList.divList.filter((v)=>{return v.is_view});
  }
  showAdhocPayment(response) {
    let url:any='/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    // //console.log(url);

    response.info_history = response.info_history ? response.info_history : [];
    if(response.info_history)
    {
      for(let i of response.info_history)
      {
        i.add_approval_info_remarks=i.add_approval_info_remarks?i.add_approval_info_remarks:'';
        i.requested_by_remarks=i.requested_by_remarks?i.requested_by_remarks:''
        i.attachments=i.attachments?i.attachments:[]
        i.attachment=[];
        i.attachment=this.webservice.makeAttachment(i.attachments);
      }
    }
    response.is_history_only = response.is_need_info ? response.is_need_info : false;
    response.is_need_info = response.info_history.length > 0 ? true : false;

    response.add_approval_info_remarks = response.add_approval_info_remarks ? response.add_approval_info_remarks : ''
    response.add_requested_by = response.add_requested_by ? response.add_requested_by : ''
    response.actual_date=this.webservice.formatDate(response.actual_date,'dd-mm-yy','-')?this.webservice.formatDate(response.actual_date,'dd-mm-yy','-'):''

    this.commonVariableList.divList.push(
      {
        "display": 'Payment Reference Number', "value": response.payment_reference_no?response.payment_reference_no:'', "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view":url!='/adhoc-advance-payment-approval'?true:false, "input_type": 'text'
      },
      {
        "display": 'Actual Payment Date', "value": response.actual_date?response.actual_date:'', "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": url!='/adhoc-advance-payment-approval'?true:false, "input_type": 'text'
      }
      );

  }
  showInvoicePartPayment(response) {
    this.commonVariableList.divList.push(
      {
        "display": 'Payment Reference Number', "value": response.payment_reference_no, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": false, "input_type": 'text'
      });
  }
  showInvoiceRetentionPayment(response) {
    this.commonVariableList.divList.push(
      {
        "display": 'Payment Reference Number', "value": response.payment_reference_no, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": false, "input_type": 'text'
      });
  }
  showSalesInvoice(response) {
    this.commonVariableList.divList.push(
      {
        "display": 'Instructions', "value": response.instructions, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      });
  }
  showProformaInvoice(response) {
    this.commonVariableList.divList.push(
      {
        "display": 'Freight Cost', "value": response.freight_cost, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Less Discount', "value": response.discount_value, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Other Charge', "value": response.installation_charge, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Remaning Balance', "value": response.remaining_amount, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      });
  }


  showSalesData(response) {
    this.commonVariableList.divList.push(
      {
        "display": 'Instructions', "value": response.instructions, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      });
  }

  showStn(response) {
    this.commonVariableList.divList.push(
      { "display": 'Transfer Date', "value": response.date_of_transfer, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true, "input_type": 'text' },

    );
  }
  showPr(response) {
    response.info_history = response.info_history ? response.info_history : [];
    if(response.info_history)
    {
      for(let i of response.info_history)
      {
        i.add_approval_info_remarks=i.add_approval_info_remarks?i.add_approval_info_remarks:'';
        i.requested_by_remarks=i.requested_by_remarks?i.requested_by_remarks:''
        i.attachments=i.attachments?i.attachments:[]
        i.attachment=[];
        i.attachment=this.webservice.makeAttachment(i.attachments);
      }
    }
    response.is_history_only = response.is_need_info ? response.is_need_info : false;
    response.is_need_info = response.info_history.length > 0 ? true : false;

    response.add_approval_info_remarks = response.add_approval_info_remarks ? response.add_approval_info_remarks : ''
    response.add_requested_by = response.add_requested_by ? response.add_requested_by : ''

    this.commonVariableList.divList.push(
      {
        "display": this.getRemarksLabel(), "id": "remarks", "value": response.remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": response.remarks == '' ? false : true, "input_type": 'text'
      },
      {
        "display": 'Required Additional Info', "value": response.add_approval_info_remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.add_approval_info_remarks!='' && response.add_approval_info_remarks!=undefined) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info Requested By', "value": response.add_requested_by, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.add_requested_by!=''&&response.add_requested_by!=undefined) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info History', "value": response.info_history, "div_size": 'col-sm-12', "is_history": true, "is_array": true, "is_attachment": true, "is_disabled": true, "is_view": response.is_need_info ? true : false, "input_type": 'text'
      }
    );
  }
  showIr(response) {
    this.irFields.applyIrFieldsTable(this.company_setup);
    response.info_history = response.info_history ? response.info_history : [];
    if(response.info_history)
    {
      for(let i of response.info_history)
      {
        i.add_approval_info_remarks=i.add_approval_info_remarks?i.add_approval_info_remarks:'';
        i.requested_by_remarks=i.requested_by_remarks?i.requested_by_remarks:''
      }
    }
    response.is_history_only = response.is_need_info ? response.is_need_info : false;
    response.is_need_info = response.info_history.length > 0 ? true : false;

    response.add_approval_info_remarks = response.add_approval_info_remarks ? response.add_approval_info_remarks : ''
    response.add_requested_by = response.add_requested_by ? response.add_requested_by : ''

    this.commonVariableList.divList.push(
      {
        "display": this.irFields.getIrFieldDisplayName(this.company_setup, 'remarks', 'Remarks'), "value": response.remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": response.remarks == '' ? false : this.irFields.isIrFieldVisibleInModule(this.company_setup, 'remarks'), "input_type": 'text'
      },
      {
        "display": 'Required Additional Info', "value": response.add_approval_info_remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.is_need_info && response.is_history_only) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info Requested By', "value": response.add_requested_by, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.is_need_info && response.is_history_only) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info History', "value": response.info_history, "div_size": 'col-sm-12', "is_history": true, "is_array": true, "is_attachment": true, "is_disabled": true, "is_view": response.is_need_info ? true : false, "input_type": 'text'
      }
    );
  }
  showIRHistory(response) {
    response.info_history = response.info_history ? response.info_history : [];
    if(response.info_history)
    {
      for(let i of response.info_history)
      {
        i.add_approval_info_remarks=i.add_approval_info_remarks?i.add_approval_info_remarks:'';
        i.requested_by_remarks=i.requested_by_remarks?i.requested_by_remarks:''
      }
    }
    response.is_history_only = response.is_need_info ? response.is_need_info : false;
    response.is_need_info = response.info_history.length > 0 ? true : false;

    response.add_approval_info_remarks = response.add_approval_info_remarks ? response.add_approval_info_remarks : ''
    response.add_requested_by = response.add_requested_by ? response.add_requested_by : ''

    this.commonVariableList.divList.push(
      {
        "display": 'Remarks', "value": response.remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": response.remarks == '' ? false : true, "input_type": 'text'
      },
      {
        "display": 'Required Additional Info', "value": response.add_approval_info_remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.is_need_info && response.is_history_only) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info Requested By', "value": response.add_requested_by, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.is_need_info && response.is_history_only) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info History', "value": response.info_history, "div_size": 'col-sm-12', "is_history": true, "is_array": true, "is_attachment": true, "is_disabled": true, "is_view": response.is_need_info ? true : false, "input_type": 'text'
      }
    );
  }
  showMpr(response) {
    this.commonVariableList.divList = [];
  }

  showMp(response) {
    this.commonVariableList.divList = [];
  }
  showLogistics(response) {
    this.commonVariableList.divList = [];
  }
  showSi(response) {
    this.commonVariableList.divList = [];
  }
  diff_json_data = {};
  old_json_data = {};
  show_difference : boolean = false;
  showPo(response) {
    this.diff_json_data = this.divDetails.diff_json_data ? this.divDetails.diff_json_data : {};
    this.show_difference = this.divDetails.show_difference && this.divDetails.show_difference=='1' ? true : false;
    this.old_json_data = this.divDetails.old_json_data ? this.divDetails.old_json_data : {};
    response.info_history = response.info_history ? response.info_history : [];
    this.divDetails.data.quotationAttachments = this.divDetails.data.quotationAttachments ? this.divDetails.data.quotationAttachments : [];
    this.quotation_obtained = this.divDetails.data.quotation_obtained ? this.divDetails.data.quotation_obtained : '';
    this.no_of_quotation = this.divDetails.data.no_of_quotation ? this.divDetails.data.no_of_quotation : '';
    this.quotation_Attachments =this.webservice.makeAttachment(this.divDetails.data.quotationAttachments);

    if(response.info_history)
    {
      for(let i of response.info_history)
      {
        i.add_approval_info_remarks=i.add_approval_info_remarks?i.add_approval_info_remarks:'';
        i.requested_by_remarks=i.requested_by_remarks?i.requested_by_remarks:''
        i.attachments=i.attachments?i.attachments:[]
        i.attachment=[];
        i.attachment=this.webservice.makeAttachment(i.attachments);
      }
    }
    // //console.log(response.info_history);
    response.is_history_only = response.is_need_info ? response.is_need_info : false;
    response.is_need_info = response.info_history.length > 0 ? true : false;

    response.additional_extra_terms_condition = response.additional_extra_terms_condition ? response.additional_extra_terms_condition : '';
    response.po_series_order_type = response.po_series_order_type ? response.po_series_order_type : ''; 
    if(response.po_series_order_type != ''){
      this.getPoType(response.po_series_order_type);
    }   

    response.add_approval_info_remarks = response.add_approval_info_remarks ? response.add_approval_info_remarks : ''
    response.add_requested_by = response.add_requested_by ? response.add_requested_by : '';
    response.additional_terms_condition = response.additional_terms_condition ? response.additional_terms_condition: " ";
    response.vendor_item_attachments = response.vendor_item_attachments ? response.vendor_item_attachments : [];
    response.vendor_attachments = response.vendor_attachments ? response.vendor_attachments : [];
    console.log('response.vendor_item_attachments',response.vendor_item_attachments)
    console.log('response.vendor_attachments',response.vendor_attachments)
    let url:any='/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    this.commonVariableList.divList.push(
      {
        "display": 'SO Reference No',"id": "so_reference_no", "value": response.so_reference_no, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.so_reference_no == '' || response.so_reference_no == null || this.company_setup.is_so_ref_no_visible_in_add_direct_po  == '0') ? false : true, "input_type": 'text'
      },
      {
        "display": 'Payment Terms', "id": "payment_terms", "value": response.payment_terms, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.payment_terms == '' || response.payment_terms == null || this.company_setup.is_payment_terms_visible_in_add_direct_po  == '0' ) ? false : true, "input_type": 'text'
      },
      {
        "display": 'Payment Mode', "id": "payment_mode", "value": response.payment_mode, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": this.company_setup.mode_of_payment_po_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Remarks', "id": "remarks", "value": response.remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.remarks == '' || response.remarks == null) ? false : true, "input_type": 'text'
      },
      // {
      //   "display": 'Additional Terms & Conditions', "value": response.additional_terms_condition, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.additional_terms_condition == '' || response.additional_terms_condition == null) ? false : true, "input_type": 'text'
      // },
      {
        "display": this.company_setup.custom_name_for_terms_and_conditions_in_direct_po, "id": "additional_terms_condition", "value": response.additional_terms_condition, "div_size": (response.additional_terms_condition.length>500)?'col-sm-6 div1':'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (this.company_setup.enable_po_type_order_in_po == '0' && url!='/po-approval') ? true : false, "input_type": 'html'
      },
      {
        "display": 'Required Additional Info',"id": "add_approval_info_remarks", "value": response.add_approval_info_remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.is_need_info && response.is_history_only) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info Requested By',"id": "add_requested_by", "value": response.add_requested_by, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.is_need_info && response.is_history_only) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info History', "id": "info_history", "value": response.info_history, "div_size": 'col-sm-12', "is_history": true, "is_array": true, "is_attachment": true, "is_disabled": true, "is_view": response.is_need_info ? true : false, "input_type": 'text'
      }
     
      ,{
        "display": this.additinalTermCondition.length > 0 ? this.additinalTermCondition[0].heading : this.company_setup.custom_name_for_terms_and_conditions_in_direct_po, "id": "additional_terms_condition", "value": response.additional_terms_condition, "div_size": (response.additional_terms_condition.length>500)?'col-sm-6 div1':'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view":  this.company_setup.enable_po_type_order_in_po == '1' ? true : false, "input_type": 'html'
      }
      ,{
        "display": this.extraAdditinalTermCondition.length > 0 ? this.extraAdditinalTermCondition[0].heading : '', "id": "extra_additional_terms_condition", "value": response.additional_extra_terms_condition, "div_size": (response.additional_extra_terms_condition.length>500)?'col-sm-6 div1':'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view":  this.company_setup.enable_po_type_order_in_po == '1' ? true : false, "input_type": 'html'
      },
    );
  }
  showIrn(response) {
    this.commonVariableList.divList = [];
  }
  showGrn(response) {
    this.commonVariableList.divList = [];
  }
  showAndroidInvoice(response)
  {

    response.invoice_amount = response.invoice_amount ? response.invoice_amount : '0'

    this.commonVariableList.divList.push(

      {
        "display": 'Invoice Amount Incluesive', "value": this.webservice.numberWithCommas(response.invoice_amount), "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
    );
  }
  showRecurringInvoice(response) {
    response.info_history = response.info_history ? response.info_history : [];
    if(response.info_history)
    {
      for(let i of response.info_history)
      {
        i.add_approval_info_remarks=i.add_approval_info_remarks?i.add_approval_info_remarks:'';
        i.requested_by_remarks=i.requested_by_remarks?i.requested_by_remarks:''
        i.attachments=i.attachments?i.attachments:[]
        i.attachment=[];
        i.attachment=this.webservice.makeAttachment(i.attachments);
      }
    }
    response.is_history_only = response.is_need_info ? response.is_need_info : false;
    response.is_need_info = response.info_history.length > 0 ? true : false;
    response.invoice_discount_amount = response.invoice_discount_amount ? response.invoice_discount_amount : '0'
    response.add_approval_info_remarks = response.add_approval_info_remarks ? response.add_approval_info_remarks : ''
    response.add_requested_by = response.add_requested_by ? response.add_requested_by : '';


    this.commonVariableList.divList.push(
      {
        "display": 'Invoice Remarks', "value": response.invoice_remarks ? response.invoice_remarks : '', "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true , "input_type": 'text'
      },
      
      {
        "display": 'Required Additional Info', "value": response.add_approval_info_remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.is_need_info && response.is_history_only && response.add_requested_by!='') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info Requested By', "value": response.add_requested_by, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.is_need_info && response.is_history_only && response.add_requested_by!='') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info History', "value": response.info_history, "div_size": 'col-sm-12', "is_history": true, "is_array": true, "is_attachment": true, "is_disabled": true, "is_view": response.is_need_info ? true : false, "input_type": 'text'
      }
    );
  }
  showInvoice(response) {
    response.info_history = response.info_history ? response.info_history : [];
    if(response.info_history)
    {
      for(let i of response.info_history)
      {
        i.add_approval_info_remarks=i.add_approval_info_remarks?i.add_approval_info_remarks:'';
        i.requested_by_remarks=i.requested_by_remarks?i.requested_by_remarks:''
        i.attachments=i.attachments?i.attachments:[]
        i.attachment=[];
        i.attachment=this.webservice.makeAttachment(i.attachments);
      }
    }
    response.is_history_only = response.is_need_info ? response.is_need_info : false;
    response.is_need_info = response.info_history.length > 0 ? true : false;
    response.invoice_discount_amount = response.invoice_discount_amount ? response.invoice_discount_amount : '0'
    response.add_approval_info_remarks = response.add_approval_info_remarks ? response.add_approval_info_remarks : ''
    response.add_requested_by = response.add_requested_by ? response.add_requested_by : '';
    response.payment_mode = response.payment_mode ? response.payment_mode : '';


    response.proposed_pod_deduction_amount = this.webservice.convertNaN(response.proposed_pod_deduction_amount)?this.webservice.convertNaN(response.proposed_pod_deduction_amount):0;
    response.proposed_cod_deduction_amount = this.webservice.convertNaN(response.proposed_cod_deduction_amount)?this.webservice.convertNaN(response.proposed_cod_deduction_amount):0;

    response.approved_pod_deduction_amount = this.webservice.convertNaN(response.approved_pod_deduction_amount)?this.webservice.convertNaN(response.approved_pod_deduction_amount):0;
    response.approved_cod_deduction_amount = this.webservice.convertNaN(response.approved_cod_deduction_amount)?this.webservice.convertNaN(response.approved_cod_deduction_amount):0;

    this.company_setup.comma_separate_currency_code = this.company_setup.comma_separate_currency_code ? this.company_setup.comma_separate_currency_code : 'IND';
    this.company_setup.is_enable_comma_separate_price = this.company_setup.is_enable_comma_separate_price ? this.company_setup.is_enable_comma_separate_price : '0';
    this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : '2';
    this.company_setup.acconting_remarks_visible_mandatory_for_last_approval = this.company_setup.acconting_remarks_visible_mandatory_for_last_approval  ? this.company_setup.acconting_remarks_visible_mandatory_for_last_approval  :'0'
    if(this.page_url=='invoice-summary'|| this.page_url=='all-approved-invoices')
      {
        this.commonVariableList.divList.push(
         
         {
             "display": 'Accounting Team Remarks', "value": response.accounting_team_remarks ? response.accounting_team_remarks : '', "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true,
              "is_view":this.company_setup.accounting_team_remarks =='1' || (this.company_setup.acconting_remarks_visible_mandatory_for_last_approval == '1' && response.check_last_approval =='1') ?true :false , "input_type": 'text'
         })
      }

    this.commonVariableList.divList.push(
      {
        "display": 'Invoice Remarks', "value": response.invoice_remarks ? response.invoice_remarks : '', "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": this.company_setup.is_remarks_require_in_invoice == '1' ? true : false, "input_type": 'text'
      },
    //  {
    //      "display": 'Accounting Team Remarks', "value": response.accounting_team_remarks ? response.accounting_team_remarks : '', "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view":this.company_setup.accounting_team_remarks =='1' ?true :false , "input_type": 'text'
    //  },
      {
        "display": 'Freight Cost', "value": this.webservice.numberWithCommas(response.freight_cost, 2, this.company_setup.comma_separate_currency_code, this.company_setup.is_enable_comma_separate_price), "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": false, "input_type": 'text'
      },
      {
        "display": 'Less Discount', "value": this.webservice.numberWithCommas(response.discount_value, 2, this.company_setup.comma_separate_currency_code, this.company_setup.is_enable_comma_separate_price), "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": false, "input_type": 'text'
      },
      {
        "display": 'Other Charge', "value": this.webservice.numberWithCommas(response.installation_charge, 2, this.company_setup.comma_separate_currency_code, this.company_setup.is_enable_comma_separate_price), "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": false, "input_type": 'text'
      },
      {
        "display": 'Discount Amount', "value": this.webservice.numberWithCommas(response.invoice_discount_amount, 2, this.company_setup.comma_separate_currency_code, this.company_setup.is_enable_comma_separate_price), "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": this.company_setup.in_invoice_discount_amount_is_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Remaining Balance', "value": this.webservice.numberWithCommas(response.remaining_amount, 2, this.company_setup.comma_separate_currency_code, this.company_setup.is_enable_comma_separate_price), "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display":this.webservice.getColumnName(this.company_setup.invoice_extra_columns,'proposed_pod_deduction_amount','Proposed POD Deduction Amount'),
         "value": this.webservice.numberWithCommas(response.pod_deduction_amount, 2, this.company_setup.comma_separate_currency_code, this.company_setup.is_enable_comma_separate_price), "div_size": 'col-sm-2 div1',
          "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view":this.webservice.is_column_visible(this.company_setup.invoice_extra_columns,'proposed_pod_deduction_amount',false) && this.company_setup.invoice_raiser_hide_tds=='0', "input_type": 'text'
      },
      {
        "display":this.webservice.getColumnName(this.company_setup.invoice_extra_columns,'proposed_cod_deduction_amount','Proposed COD Deduction Amount'),
         "value": this.webservice.numberWithCommas(response.cod_deduction_amount, 2, this.company_setup.comma_separate_currency_code, this.company_setup.is_enable_comma_separate_price), "div_size": 'col-sm-2 div1',
          "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view":this.webservice.is_column_visible(this.company_setup.invoice_extra_columns,'proposed_cod_deduction_amount',false) && this.company_setup.invoice_raiser_hide_tds=='0', "input_type": 'text'
      },
      {
        "display":this.webservice.getColumnName(this.company_setup.invoice_extra_columns,'approved_pod_deduction_amount','Approved POD Deduction Amount'),
         "value": this.webservice.numberWithCommas(response.approved_pod_deduction_amount, 2, this.company_setup.comma_separate_currency_code, this.company_setup.is_enable_comma_separate_price), "div_size": 'col-sm-2 div1',
          "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true,
           "is_view":(this.webservice.is_column_visible(this.company_setup.invoice_extra_columns,'approved_pod_deduction_amount',false) && (parseFloat(response.approved_pod_deduction_amount)>0) && this.company_setup.invoice_raiser_hide_tds=='0')?false:false, "input_type": 'text'
      },
      {
        "display":this.webservice.getColumnName(this.company_setup.invoice_extra_columns,'approved_cod_deduction_amount','Approved COD Deduction Amount'),
         "value": this.webservice.numberWithCommas(response.approved_cod_deduction_amount, 2, this.company_setup.comma_separate_currency_code, this.company_setup.is_enable_comma_separate_price), "div_size": 'col-sm-2 div1',
          "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true,
          "is_view":(this.webservice.is_column_visible(this.company_setup.invoice_extra_columns,'approved_cod_deduction_amount',false) && (parseFloat(response.approved_cod_deduction_amount)>0) && this.company_setup.invoice_raiser_hide_tds=='0')?false:false, "input_type": 'text'
        },

      {
        "display": 'Mode of Payment', "value": response.payment_mode, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.payment_mode != '' && response.payment_mode != undefined && response.payment_mode != null) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Required Additional Info', "value": response.add_approval_info_remarks, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.is_need_info && response.is_history_only && response.add_requested_by!='') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info Requested By', "value": response.add_requested_by, "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true, "is_view": (response.is_need_info && response.is_history_only && response.add_requested_by!='') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Additional Info History', "value": response.info_history, "div_size": 'col-sm-12', "is_history": true, "is_array": true, "is_attachment": true, "is_disabled": true, "is_view": response.is_need_info ? true : false, "input_type": 'text'
      }
    );
  }
  showMyAdvanceData(response) {
    this.commonVariableList.divList = [];
  }
  showEmployeeAdvancePaymentData(response) {
    this.commonVariableList.divList = [];
  }
  showDCNote(response) {
    response.info_history = response.info_history ? response.info_history : [];
    if(response.info_history)
    {
      for(let i of response.info_history)
      {
        i.add_approval_info_remarks=i.add_approval_info_remarks?i.add_approval_info_remarks:'';
        i.requested_by_remarks=i.requested_by_remarks?i.requested_by_remarks:''
      }
    }
    response.is_history_only = response.is_need_info ? response.is_need_info : false;
    response.is_need_info = response.info_history.length > 0 ? true : false;

    response.add_approval_info_remarks = response.add_approval_info_remarks ? response.add_approval_info_remarks : ''
    response.add_requested_by = response.add_requested_by ? response.add_requested_by : ''
    this.commonVariableList.divList.push(
      {
        "display":response.note_type=='1'?'Send mail to Vendor':'Send Mail to customer',
         "value":response.send_vendor_mail=='1'?true:false,
          "div_size": 'col-sm-2 div1', "is_history": false, "is_array": false, "is_attachment": false, "is_disabled": true,
           "is_view": true,
            "input_type": 'checkbox'
      },

    );
  }
  getFile(url)
  {
    if(url!=''&&url!=null&&url!=undefined)
    {
      window.open(url,'_blank');
    }
  }
  isCorrectData(arr)
  {
    // //console.log('err')
    // //console.log(arr);
    return Array.isArray(arr)?(arr.length>0?true:false):false;
  }

  additinalTermCondition: any = [];
  extraAdditinalTermCondition: any = [];
  getPoType(val){
    if(val == 'co'){
      val = 'cap'
    }
    this.additinalTermCondition = this.company_setup.po_for_additional_term_and_condition_list.filter(v => v.id == val);
    this.commonVariableList.additional_terms_condition = this.additinalTermCondition.length > 0 ? this.additinalTermCondition[0].text : '';
    this.extraAdditinalTermCondition = this.company_setup.po_for_extra_additional_term_and_condition_list.filter(v => v.id == val);
    this.commonVariableList.additional_extra_terms_condition = this.extraAdditinalTermCondition.length > 0 ? this.extraAdditinalTermCondition[0].text : '';
  }
  stripHtmlTags(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4208491149/src/src/app/generic-ui-components/generic-afterdiv-list/generic-afterdiv-list.component.ts